import { Injectable } from '@angular/core';
import {
  PublicOfferInterestFormDetails,
  SendPublicOfferInterestFormPayload,
  SendPublicOfferInterestFormResponse,
} from '@features/public-offer-interest-form/utils/models/public-offer-interest-form.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicOfferInterestFormService extends HttpHandler {
  validateOfferInterestForm(offerHash: string): Observable<HttpResponse<PublicOfferInterestFormDetails>> {
    const url: string = environment.apiUrls.offers.interests.validate;
    const params = { hash: offerHash };
    return this.post<HttpResponse<PublicOfferInterestFormDetails>>(url, params);
  }

  sendOfferInterestForm(
    payload: SendPublicOfferInterestFormPayload
  ): Observable<HttpResponse<SendPublicOfferInterestFormResponse>> {
    const url: string = environment.apiUrls.offers.interests.send;
    const formData: FormData = new FormData();
    Object.entries(payload)
      .filter(([, value]) => value)
      .forEach(([key, value]) => {
        formData.append(key, typeof value === 'number' ? value.toString() : value);
      });
    return this.post<HttpResponse<SendPublicOfferInterestFormResponse>>(url, formData, {
      recaptchaAction: 'submit_public_offer_interest_form',
    });
  }
}
